import React, { useEffect } from 'react';
import { base_url } from '../../AppConfig';

function SignInStart(props) {

    useEffect(() => {
        let location = window.location.href;
        let queryParams = {
            client_id: "51deaf95-d7fa-4459-956c-a62664b57877",
            redirect_uri: `${location.replace('/sign-in/sign-in-start', '')}/sign-in/sign-in-end`,
            state: "prime_auth",
            scope: "learner:read,learner:write",
            response_type: "CODE"
        };

        let authorizeEndpoint = `${base_url}/oauth/o/authorize?logoutAfterAuthorize=true&account=107442&${toQueryString(queryParams)}`;
        window.location.assign(authorizeEndpoint);
    }, []);

    return (<></>);
}

export function _guid() {
    var val = Math.floor(1000 + Math.random() * 9000);
    return `${val}`;
}

export function toQueryString(queryParams) {
    let encodedQueryParams = [];
    for (let key in queryParams) {
        encodedQueryParams.push(key + "=" + encodeURIComponent(queryParams[key]));
    }
    return encodedQueryParams.join("&");
}

export default SignInStart;